
import i18n from "i18next";
import { api } from "api";

import {
    showModal,
    hideModal
} from "actions";
import Block from "./elements/Block";
import { Trans } from "react-i18next";

import React, { Component } from "react";
// import "./modalbackdrop.css";

class BodyMetrics extends Component {
    state = {
        bodySize: null,
        tshirtSize: null,
        pantSize: null,
        isBlock: false
    };

    componentDidMount() {
        this.fetchSize();
    }

    fetchSize = () => {
        this.setState({ isBlock: true });
        api.get(`/api/profile/get`).then((response) => {
            this.setState({
                bodySize: response.data.data.bodySize ? response.data.data.bodySize.value : null,
                tshirtSize: response.data.data.tshirtSize ? response.data.data.tshirtSize.value : null,
                pantSize: response.data.data.pantSize ? response.data.data.pantSize.value : null
            });
        })
            .catch((err) => {
                console.error(err);
            }).finally(() => {
                this.setState({ isBlock: false });
            })
    };

    handleSubmit = (e) => {
        this.setState({ isBlock: true });
        e.preventDefault();
        api
            .post("/api/profile/update", {
                bodySize: this.state.bodySize,
                tshirtSize: this.state.tshirtSize,
                pantSize: this.state.pantSize
            })
            .then((res) => {
                console.log("then profile size update : " + res);
                this.props.hideModal()
            })
            .catch((e) => {
                console.log("catch profile size update : " + e);
            });
    };



    render() {
        return (
            <Block isBlock={this.state.isBlock}>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "auto",
                        gridAutoRows: "true",
                        alignItems: "center",
                        gap: "10px",
                        textAlign: "center"
                    }}
                >

                    <div>
                        <p style={{ textAlign: "left", color: "red" }}>*Kot bedenleri değildir, bu doğrultuda seçim yapınız.</p>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                                <label htmlFor="pantSize">
                                    <Trans desc="Pantolon Boyu">10348</Trans>
                                </label>
                                <div className="inner-addon right-addon">
                                    {/* <span className="icon-icon-table-dropdown"></span> */}
                                    <select
                                        className="custom-select"
                                        id="pantSize"
                                        value={this.state.pantSize ?? ""}
                                        onChange={(e) => {
                                            this.setState({ pantSize: e.currentTarget.value });

                                        }
                                        }
                                    >
                                        <option value="">
                                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                                        </option>
                                        <option value="36">36</option>
                                        <option value="38">38</option>
                                        <option value="40">40</option>
                                        <option value="42">42</option>
                                        <option value="44">44</option>
                                        <option value="46">46</option>
                                        <option value="48">48</option>
                                        <option value="50">50</option>
                                        <option value="52">52</option>
                                        <option value="54">54</option>
                                        <option value="56">56</option>
                                        <option value="58">58</option>
                                        <option value="60">60</option>
                                        <option value="62">62</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                                <label htmlFor="tshirtSize">
                                    <Trans desc="T-Shirt Boyu">10349</Trans>
                                </label>
                                <div className="inner-addon right-addon">
                                    {/* <span className="icon-icon-table-dropdown"></span> */}
                                    <select
                                        id="tshirtSize"
                                        className="custom-select"
                                        onChange={(e) => {
                                            this.setState({ tshirtSize: e.currentTarget.value })
                                        }
                                        }
                                        value={this.state.tshirtSize ?? ""}
                                    >
                                        <option value="">
                                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                                        </option>
                                        <option value="1">XS</option>
                                        <option value="2">S</option>
                                        <option value="3">M</option>
                                        <option value="4">L</option>
                                        <option value="5">XL</option>
                                        <option value="6">XXL</option>
                                        <option value="7">3XL</option>
                                        <option value="8">4XL</option>
                                        <option value="9">5XL</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                                <label htmlFor="shirtSize">
                                    <Trans desc="Vücut Ölçüsü">10352</Trans>
                                </label>
                                <div className="inner-addon right-addon">
                                    {/* <span className="icon-icon-table-dropdown"></span> */}
                                    <select
                                        id="bodySize"
                                        className="custom-select"
                                        onChange={(e) =>
                                            this.setState({ bodySize: e.currentTarget.value })
                                        }
                                        value={this.state.bodySize ?? ""}
                                    >
                                        <option value="">
                                            {i18n.t("10354")} {/*Boy Seçiniz*/}
                                        </option>
                                        <option value="1">XS</option>
                                        <option value="2">S</option>
                                        <option value="3">M</option>
                                        <option value="4">L</option>
                                        <option value="5">XL</option>
                                        <option value="6">XXL</option>
                                        <option value="7">3XL</option>
                                        <option value="8">4XL</option>
                                        <option value="9">5XL</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className="col-sm-12 col-md-12 col-lg-12 text-right">

                        <button
                            type="submit"
                            className="btn btn-kaydet"
                            style={{ backgroundColor: "#2d96cd", color: "white" }}
                            onClick={(e) => this.handleSubmit(e)}
                        >
                            <Trans desc="Kaydet">10328</Trans>
                        </button>

                    </div>
                </div>
            </Block>
        )
    }

};

export default BodyMetrics;